import { get, post } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getOfferPartnerQuestions = (documentId, siteId, partnerId) => {
  return get(`${url}/questionnaire/${documentId}/${siteId}/partner/${partnerId}/questions`);
};

const getOfferPartnerQuestionActions = (documentId, siteId, partnerId) => {
  return get(`${url}/questionnaire/${documentId}/${siteId}/partner/${partnerId}/questionActions`);
};

const setQuestionnaire = (documentId, siteId, partnerId, questionnaireId) => {
  return post(`${url}/questionnaire/set-questionnaire`, {
    documentId: documentId,
    siteId: siteId,
    partnerId: partnerId,
    questionnaireId: questionnaireId
  });
};

const startQuestion = (documentId, siteId, partnerId, questionnaireId, startQuestionNo) => {
  return post(`${url}/questionnaire/start`, {
    header: {
      documentId: documentId,
      siteId: siteId,
      partnerId: partnerId,
      questionnaireId: questionnaireId,
      startQuestionNo: startQuestionNo,
      questions: []
    }
  });
};

const nextQuestion = (documentId, siteId, partnerId, questionnaireId, questions) => {
  return post(`${url}/questionnaire/next`, {
    header: {
      documentId: documentId,
      siteId: siteId,
      partnerId: partnerId,
      questionnaireId: questionnaireId,
      actualAnsweredQuestions: questions
    }
  });
};
const finishQuestionnaire = (documentId, siteId, partnerId, questionnaireId, questions) => {
  return post(`${url}/questionnaire/finish`, {
    header: {
      documentId: documentId,
      siteId: siteId,
      partnerId: partnerId,
      questionnaireId: questionnaireId,
      actualAnsweredQuestions: questions
    }
  });
};

const exp = {
  getOfferPartnerQuestions,
  getOfferPartnerQuestionActions,
  setQuestionnaire,
  startQuestion,
  nextQuestion,
  finishQuestionnaire
};
export default exp;
